import React from 'react';

const styles = {
  container: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    minHeight: '60vh', color: '#94a3b8', textAlign: 'center', padding: 40
  },
  title: { fontSize: 24, fontWeight: 700, color: '#f87171', marginBottom: 12 },
  message: { fontSize: 14, color: '#64748b', marginBottom: 24, maxWidth: 500 },
  btn: {
    padding: '10px 24px', background: '#3b82f6', color: '#fff', border: 'none',
    borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600
  }
};

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[SIGEPRO] ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <div style={styles.title}>Une erreur est survenue</div>
          <div style={styles.message}>
            {this.state.error?.message || 'Erreur inattendue dans l\'application.'}
          </div>
          <button style={styles.btn} onClick={() => window.location.reload()}>
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
